import { useMatches } from 'react-router';

import { TCustomMatch } from '@/shared/hooks/use-typed-matches/use-typed-matches.types';

export const useTypedMatches = (): Array<TCustomMatch> => {
  return useMatches() as Array<TCustomMatch>;
};
